import { Box, Button, Container, Step, StepLabel, Stepper } from '@mui/material';
import { Form } from '@unform/web';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import { ContainerButton, Input, SelectInput, TextTitle, Title } from '../../../../styles/global';
import { Link, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faX } from '@fortawesome/free-solid-svg-icons';
import useCargo from '../../../../../actions/cruds/useCargo';
import { FormHandles } from '@unform/core';
import organizeDataSelect from '../../../../../utils/organizeDataSelect';
import useUsuario from '../../../../../actions/cruds/useUsuario';
import Panel from '../../../../components/Panel';
import SecondaryTable from '../../../../components/SecondaryTable';
import usePap from '../../../../actions/cruds/usePap';
import { GridApi, GridColDef, gridColumnDefinitionsSelector, gridColumnFieldsSelector, gridColumnLookupSelector, gridFilterableColumnDefinitionsSelector, gridFilterableColumnLookupSelector, GridRenderEditCellParams, GridToolbar, GridValueFormatterParams, useGridApiRef } from '@mui/x-data-grid';
import {BudgetTable} from './styles';
import { useToast } from '../../../../hooks/toast';
import usePapOrcamento from '../../../../actions/cruds/usePapOrcamento';
import { formatarReais, formatarRealparaDecimal } from '../../../../utils/formatDados';
import usePoa from '../../../../actions/cruds/usePoa';
import usePoaOrcamento from '../../../../actions/cruds/usePoaOrcamento';
import { Co2Sharp } from '@mui/icons-material';
import InputNumberFormat from '../../../../components/InputNumberFormat';

// import { Container } from './styles';

interface ITitleRow {
    field: string;
    headerName: string;
    flex?: number;
    editable?: boolean;
    sortable?: boolean;
}

const PoaOrcamento: React.FC = () => {
    const [titleRows, setTitleRows] = useState<ITitleRow[]>([]);

    const { idPoa } = useParams();

    const { getPoaBudget, poaBudget } = usePoa();
    const { createPoaOrcamento, updatePoaOrcamento } = usePoaOrcamento();
    const {addToast} = useToast();

    useEffect(() => {
        getPoaBudget([{ label: "id", value: idPoa }]);
    }, []);

    useEffect(() => {
        if(!poaBudget.data) return;
        // console.log('budget2: ', poaBudget);

        // Inserção dinamica do titulo de coluna da tabela, essa parte na descrição inical
        setTitleRows(
            [
                { 
                    field: "pap",
                    headerName: `POA - ${poaBudget.data[0].poa ?? ""} - ${poaBudget.data[0].comittee.nome ?? ""}`,
                    sortable: false, flex: 3
                }
            ]
        );


        setTitleRows(
            titleRows => 
            [
                ...titleRows,
                { 
                    field: `budget_value_year_${poaBudget.data[0].poa}`,
                    headerName: poaBudget.data[0].poa.toString(),
                    sortable: false,
                    flex: 1,
                    editable: true,
                    valueFormatter: (params: GridValueFormatterParams<number>) => {
                        if (params.value == null) {
                            return "R$ 0,00";
                        }
                        return params.value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
                    },
                    renderEditCell: (params: GridRenderEditCellParams) => (
                        <InputNumberFormat {...params} />
                    ),
                }
            ]
        );

        // console.log('titleRows: ', titleRows);
    }, [poaBudget]);

    const dataTitle: GridColDef[] = titleRows;

    const organizeData = (data: any[]) => {
        let outputArr: { id: any; nome: any; codigo: any; stacked_code: any; pap: string; }[] = [];

        /**
         * Convert a multilevel person object into one level
         * @param {Object} person The person object
         */
        const convertToOneLevel = (person, parentCode = null, poaBudget = [], papBudget = {}) => {
            const newPerson = {
                id: person.id,
                nome: person.nome,
                codigo: person.codigo,
                parent_code: parentCode ? parentCode : undefined,
                stacked_code: parentCode ? `${parentCode}.${person.codigo}` : person.codigo,
                pap: `${parentCode ? `${parentCode}.${person.codigo}` : person.codigo} - ${person.nome}`,
                [`budget_value_year_${papBudget.ano}`]: papBudget.valor
            };

            poaBudget.map(b => {
                newPerson[`budget_value_year_${b.poa.poa}`] = b.valor;
                newPerson[`budget_id_year_${b.poa.poa}`] = b.id;
                
                // console.log(b);
                // console.log("-");
            });           

            outputArr.push(newPerson);

            const idx = Object.keys(person).findIndex((key) =>
                key.startsWith('pap_programs') || key.startsWith('pap_actions') || key.startsWith('poa_sub_actions')
            );
            // console.log(idx)
            if (idx !== -1) {
                person[Object.keys(person)[idx]].map((p) => {
                        // console.log('p: ', p);
                        convertToOneLevel(
                            p,
                            newPerson.stacked_code ? newPerson.stacked_code : newPerson.codigo,
                            p.poa_budgets,
                            p.pap_budgets ? p.pap_budgets.find(a => a.ano === 2024) : undefined
                        );
                    }
                );
            }
        };

        data.forEach((p) => convertToOneLevel(p));

        // console.log('out: ', outputArr);

        let parents = outputArr.filter((value, index, self) =>
            index === self.findIndex((t) => (
                t.parent_code === value.parent_code && t.parent_code !== undefined
            ))
        );
        // console.log('parents: ', parents);
        parents = parents.filter(p => p.stacked_code.match( new RegExp('\\.','g')) && p.stacked_code.match( new RegExp('\\.','g')).length !== 3);
        // console.log('parents: ', parents);

        // Soma para os PROGRAMAS
        parents.map(parent => {
            // console.log(parent.parent_code);

            const groupToSum = outputArr.filter(f => (parent.parent_code === f.parent_code));
            // console.log('groupToSum: ', groupToSum);

            groupToSum.map(itemToSum => {

                // console.log('itemToSum: ', itemToSum);
                if (itemToSum.parent_code.includes('.')) { // Programa
                    // console.log('itemToSum: ', itemToSum);
                    const keysYears = Object.keys(itemToSum).filter(key => key.startsWith("budget_value_year_"));
                    keysYears.map((year, i) => {
                        outputArr.map((out, i) => {
                            if (out.stacked_code == itemToSum.parent_code) {
                                // console.log(out.stacked_code, itemToSum.parent_code, outputArr[i]);
                                Object.assign(outputArr[i], {
                                    [year]: groupToSum.reduce((total, obj) => ((obj[year] || 0) + (total || 0)), 0)
                                });
                            }
                        });
                    });
                }
            });

        });

        // A mesma coisa mas agora para FINALIDADES
        parents.map(parent => {
            // console.log(parent.parent_code);

            const groupToSum = outputArr.filter(f => (parent.parent_code === f.parent_code));
            // console.log('groupToSum: ', groupToSum);

            groupToSum.map(itemToSum => {

                // console.log('itemToSum: ', itemToSum);
                if (!itemToSum.parent_code.includes('.'))  { // Finalidade
                    // console.log('itemToSum: ', itemToSum);
                    const keysYears = Object.keys(itemToSum).filter(key => key.startsWith("budget_value_year_"));
                    // console.log(keysYears);
                    keysYears.map((year, i) => {
                        // console.log(year);
                        outputArr.map((out, i) => {
                            // console.log(out.stacked_code, itemToSum.parent_code);
                            if (out.stacked_code == itemToSum.parent_code) {
                                // console.log(out.stacked_code, itemToSum.parent_code, outputArr[i]);
                                Object.assign(outputArr[i], {
                                    [year]: groupToSum.reduce((total, obj) => ((obj[year] || 0) + (total || 0)), 0)
                                });
                            }
                        });
                        // console.log(outputArr);
                    });
                }
            });

        });


        function sortCallback(a, b) {

            function padParts(version) {
                return version
                    .split('.')
                    .map(function (part) {
                        return '00000000'.substring(0, 8 - part.length) + part;
                    })
                    .join('.');
            }
        
            a = padParts(a.stacked_code);
            b = padParts(b.stacked_code);
        
            return a.localeCompare(b);
        }

        // Gerador linha TOTAL por ano
        const finalidades = outputArr.filter(line => line.parent_code === undefined);
        const reducedArrayTotal = finalidades.reduce((accumulator, item) => {
            Object.keys(item).filter(key => key.startsWith("budget_value_year_")).forEach(key => {
              accumulator[key] = (accumulator[key] || 0) + item[key];
            });
            return accumulator;
        }, {});
        outputArr.push({id:9999, pap: 'TOTAL', stacked_code: "9999", ...reducedArrayTotal});
        return outputArr.sort(sortCallback);
    }

    const typePap = (params?: object) => {
        const {stacked_code, id} = params?.row;
        const dots = stacked_code.match( new RegExp('\\.','g') ); // Array com quantidade de "." encontrados

        if (dots) {
            switch (dots.length) {
                case 1:
                    return "programa";
                    
                case 2: 
                    return "acao";

                case 3:
                    
                    return "subacao";
            }
        } else { // Quando null (não achou nenhum "." cai aqui)
            if (id === 9999) {
                return "total";
            }
            return "finalidade";
        }
    }

    const apiRef = useGridApiRef();

    const processRowUpdate = React.useCallback(
        async (newRow, oldRow) => {
            // console.log(Array.from( apiRef.current.getRowModels(), ([, value]) => (value) )); // Transforma MAP em array de objetos
            // console.log('new: ', newRow);


            const rowsData = Array.from( apiRef.current.getRowModels(), ([, value]) => (value) );
            const {poa} = poaBudget.data[0];

            // Filtra subacoes que pertencem ao mesmo grupo (parent_code = ação) que sofreu alteração e as soma, não inclui a subacao que sofreu a alteração 
            const somaDadosRegistrados = rowsData.filter(row => (row.parent_code === newRow.parent_code && row.stacked_code !== newRow.stacked_code) ).reduce((prev, next) => 
                {
                    // console.log( 'n: ', next, formatarRealparaDecimal( next[[`budget_value_year_${poa}`]] || 0 ) );
                    return prev + ( next[[`budget_value_year_${poa}`]] || 0 )
                }, 0).toFixed(2);
                // console.log('somaDadosRegistrados: ', somaDadosRegistrados, newRow[[`budget_value_year_${poa}`]]);
            const somaTotal = ( parseFloat( somaDadosRegistrados ) + newRow[[`budget_value_year_${poa}`]] ).toFixed(2);

            const parent = rowsData.find(({stacked_code}) => stacked_code === newRow.parent_code);

            // console.log(parent[[`budget_value_year_${poa}`]], somaTotal);

            if ( parseFloat(somaTotal) > (parent[[`budget_value_year_${poa}`]] || 0) ) {
                throw new Error(`Soma das Sub-ações não pode ser maior que a Ação. Neste caso ${formatarReais(parent[[`budget_value_year_${poa}`]])  || "o valor da Ação ainda não foi cadastrado."}`);
            } else if ( parseFloat(somaTotal) === (parent[[`budget_value_year_${poa}`]] || 0) ) {
                addToast({type: 'info', title: 'Valor alcançado!', description: 'Soma das Sub-ações é igual ao valor da Ação correspondente.'});
            } else {
                addToast({type: 'info', title: 'Valor inferior!', description: `Soma das Sub-ações (atualmente ${formatarReais(somaTotal)}) deve ser igual a Ação correspondente (${formatarReais(parent[[`budget_value_year_${poa}`]])}).`});
            }

            const cellEdited = {};

            Object.keys(newRow).map(newKey => {
                // console.log(newKey);
                if (oldRow[newKey] != newRow[newKey]) { // Se a key for a mesma E o value for diferente (foi atualizada/criada)
                    const year = (newKey.match(/_([^_]+)$/) || [])[1] || null;
                    // console.log('true:', newRow[newKey]);
                    cellEdited['poa_id'] = idPoa;
                    cellEdited['poa_sub_action_id'] = newRow.id;
                    cellEdited['comittee_id'] = poaBudget.data[0].comittee.id;
                    cellEdited['valor'] = newRow[newKey];
                }
            });
            // console.log(oldRow, newRow, cellEdited);
            // await updatePoaOrcamento(cellEdited.budget_id, cellEdited);
            // return newRow;

            if (!Object.keys(cellEdited).length) return oldRow

            // console.log('cellEdited[[`budget_id_year_${poa}`]]: ', oldRow[[`budget_id_year_${poa}`]]);
            if (oldRow[[`budget_id_year_${poa}`]]) {
                await updatePoaOrcamento(oldRow[[`budget_id_year_${poa}`]], cellEdited);
            } else {
                await createPoaOrcamento(cellEdited);
            }
            await getPoaBudget([{ label: "id", value: idPoa }]);
            // console.log('newRow: ', cellEdited);

            // addToast({type: 'success', title: 'Valor adicionado!', description: 'Orçamento adicionado com sucesso.'});

            return newRow;
        },
        [apiRef, poaBudget],
    );
    
    const handleProcessRowUpdateError = React.useCallback((error: Error) => {
        // setSnackbar({ children: error.message, severity: 'error' });
        addToast({type: 'error', title: 'Erro: Orçamento não salvo', description: error.message});
    }, []);

    return (
        <Container>
            <Title>
                <span>Cadastro de orçamento POA</span>
            </Title>
            
            <Panel titulo='Orçamento'>
                <Grid container spacing={6}>
                    <Grid xs={12}>
                        <BudgetTable
                            apiRef={apiRef}
                            // hideFooter={true}
                            columsData={dataTitle}
                            rowsData={poaBudget.data ? organizeData(poaBudget.data[0]?.pap_finalities) : []}
                            getRowId={(row) => row.pap}
                            getRowClassName={(params) => `pap--${typePap(params)}`}
                            isCellEditable={(params) => (params.row?.stacked_code.match( new RegExp('\\.','g') ) &&
                                                            params.row?.stacked_code.match( new RegExp('\\.','g') ).length % 3 === 0)
                                                                ? true : false} // desabilita celulas que não são subações
                            processRowUpdate={processRowUpdate}
                            onProcessRowUpdateError={handleProcessRowUpdateError}
                            slots={{
                                toolbar: GridToolbar,
                            }}
                        />
                    </Grid>
                </Grid>
            </Panel>


            <ContainerButton>
                <Link to="/orcamentario/poa">
                    <button><FontAwesomeIcon icon={faX} size="1x" /> Cancelar</button>
                </Link>
            </ContainerButton>
        </Container>
    );
};

export default PoaOrcamento;